package ai.jessie.shared.onboarding

import kotlinx.serialization.Serializable

@Serializable
enum class OrganisationChoiceKind {
    MEMBERSHIP,
    INVITATION,
    NEW_ORGANISATION,
}

@Serializable
data class CompleteOnboardingRequest(
    val firstName: String,
    val lastName: String,
    val choice: OrganisationChoiceKind,
    val organisationId: String? = null,
    val invitationId: String? = null,
    val expectedRole: String? = null,
    val expectedVersion: String? = null,
    val organisationName: String? = null,
    val locale: String = "de",
)

@Serializable
data class SelectOrganisationRequest(
    val organisationId: String,
    val expectedRole: String,
    val expectedVersion: String,
)

@Serializable
data class OrganisationChoiceResponse(
    val organisationId: String,
    val name: String,
    val role: String,
    val kind: OrganisationChoiceKind,
    val version: String,
    val invitationId: String? = null,
)

@Serializable
enum class EntryDestination {
    ONBOARDING,
    ORGANISATION,
    SELECT_ORGANISATION,
    NO_MEMBERSHIP,
}

@Serializable
data class EntryResponse(
    val destination: EntryDestination,
    val organisationId: String? = null,
    val organisations: List<OrganisationChoiceResponse> = emptyList(),
)

@Serializable
data class OrganisationSelectionResponse(val organisations: List<OrganisationChoiceResponse>)

@Serializable
data class OnboardingContextResponse(
    val verifiedEmail: String,
    val choices: List<OrganisationChoiceResponse>,
    val complete: Boolean,
)

@Serializable
data class OrganisationStartResponse(
    val organisationId: String,
    val name: String,
    val role: String,
    val missingBusinessSettings: Boolean,
)

@Serializable
data class OnboardingErrorResponse(val code: String, val fields: List<String> = emptyList())
